import { render, staticRenderFns } from "./QuestionSelect.vue?vue&type=template&id=36a17efc"
import script from "./QuestionSelect.vue?vue&type=script&lang=js"
export * from "./QuestionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports